// src/pages/HomePage.js
import logo from "../assets/logo.png";

import jkmLogo from '../assets/JKM marathi.png'
import { Link, Navigate } from "react-router-dom";
import React, { useState, useEffect, useContext, useRef, useMemo } from 'react';
import './HomePage.css';

import DailyPanchang from "./DailyPanchang";
import { LanguageContext } from "../context/LanguageContext";
import SHospital from '../assets/Hospital1.jpg';
import GuruPeethLogoImg from "../assets/SRI GURUPHIT LOGO.png";

import { activitiesData } from '../data/activitiesData';
import { eventsData } from '../data/eventsData'
import CompactReelsCarousel from "../components/CompactReelsCarousel";

import Header from '../components/Layout/Header';

const navigate = Navigate

// ===== MODIFIED: Added translations for Recent Events =====
const translations = {
  mr: {
    'nav-home': 'मुख्यपृष्ठ',
    'nav-about': 'आमच्याबद्दल',
    'nav-mission': 'ध्येय',
    'nav-activities': 'कार्यक्रम',
    'nav-projects': 'प्रकल्प',
    'nav-vibhag': 'विभाग',
    'nav-wisdom': 'ज्ञान',
    'nav-datta-dham': 'दत्त धाम',
    'nav-contact': 'संपर्क',
    'nav-donate': 'देणगी',
    'hero-title': 'स्वागत आहे',
    'hero-title-accent': 'श्री स्वामी समर्थ सेवा मार्ग, दिंडोरी प्रणीत',
    'hero-desc': 'समाजाभिमुख आध्यात्मिक व सेवा संस्था, ज्यामध्ये ज्ञान, ग्रामीण विकास, आरोग्य व सांस्कृतिक वारसा यावर भर दिला जातो.',
    'activities-title': 'कार्यक्रम',
    'activities-desc': 'सद्य: चालू असलेल्या उपक्रम व सामाजिक कार्यक्रम.',
    'events-title': 'आगामी इव्हेंट्स',
    'events-desc': 'पुढील इव्हेंट्स व समाज एकत्रीकरणात सहभागी व्हा.',
    'recent-events-title': 'मागील इव्हेंट्स',
    'recent-events-desc': 'आमच्या मागील इव्हेंट्स व समाज एकत्रीकरणाची एक झलक.',
    'projects-title': 'गुरुपीठ प्रकल्प',
    'projects-desc': 'पूर्ण झालेल्या सेवा प्रकल्पांची व समाजिक पायाभूत सुविधांची झलक.',
    'mission-title': 'आमचे ध्येय',
    'mission-desc': 'मानव जीवनाशी संबंधित १८ विभागांद्वारे मानवतेला सेवा देणे.',
    'contact-title': 'संपर्क',
    'involved-title': 'सहभागी व्हा',
    'involved-desc': 'मोफत अन्नदान, आरोग्य सेवा व शिक्षण कार्यक्रमांना मदत करा. आपले योगदान मंदिर, रुग्णालय चालवण्यासाठी व गाव विकासासाठी वापरले जाते.',
    'mission-desc': 'मानव जीवनाशी संबंधित १८ विभागांद्वारे मानवतेची सेवा करणे हा आमचा हेतू आहे.',
    'mission-quote': 'समाजातील अनेक समस्यांचा अभ्यास करून परमपूज्य गुरुमाऊली अण्णासाहेब मोरे यांनी सेवेकऱ्यांचे ग्राम अभियान सुरू केले. गेल्या चार दशकांपासून परमपूज्य गुरुमाऊली हे कार्य निरंतर आणि यशस्वीपणे चालवत आहेत. "२० टक्के अध्यात्म आणि ८० टक्के समाजकार्य" या सूत्रांवर आधारित हा सेवा मार्ग अव्याहतपणे समाजासाठी झटत आहे. सेवा मार्गातील १८ विभागांमधून ग्राम व नागरी विकास अभियान अंतर्गत विविध उपक्रम राबवले जातात.',
    'mission-details': 'मानवतेची सेवा हीच ईश्वरसेवा — या तत्त्वावर १८ विविध विभागांद्वारे आरोग्य, शिक्षण, शेती, अध्यात्म, आणि समाजकल्याण क्षेत्रात कार्य केले जाते.',
    'seva-marg-mission': 'मिशन',
    'mission-point-1': 'विज्ञान व अध्यात्म यांची सांगड – समाज कल्याणकारी उपक्रम राबवणे.',
    'mission-point-2': 'आरोग्य सेवा – विविध आजारांवर मोफत सेवा व मार्गदर्शन तथा दुर्मिळ आयुर्वेदिक औषधी उपलब्ध करून देणे.',
    'mission-point-3': 'संस्कार-संस्कृती-धर्म-राष्ट्र संरक्षण – "संस्कार टिकले तर संस्कृती टिकेल; संस्कृती टिकली तर धर्म टिकेल; धर्म टिकला तर राष्ट्र टिकेल" या तत्त्वावर कार्य.',
    'mission-point-4': 'नि:शुल्क सेवा व समुपदेशन – आध्यात्मिक सेवांच्या आधारे जीवनातील विविध प्रश्नांवर मार्गदर्शन.',
    'mission-point-5': 'विषमुक्त अन्न – शाश्वत शेती व योग्य आहार, पर्यावरण पूरक जीवनशैलीबाबत जनजागृती.',
    'mission-point-6': 'जागतिक कृषी महोत्सव – भारतीय प्राचीन कृषी-ऋषी परंपरा, संस्कृती दर्शन.',
    'mission-point-7': 'कन्यादान योजना – शेतकरी, जवान व आर्थिकदृष्ट्या दुर्बल कुटुंबातील युवक-युवतींसाठी मोफत विवाह.',
    'mission-point-8': 'रोजगार व महिला सक्षमीकरण – बेरोजगारांना रोजगार व मोफत उद्योग प्रशिक्षण, कौशल्य विकास, बचत गटद्वारे महिला सक्षमीकरण.',
    'mission-point-9': 'मनःशांती – हरवलेली शांतता व आत्मविश्वास पुन्हा मिळवून देणे.',
    'seva-marg-vision': 'व्हिजन',
    'vision-point-1': 'आध्यात्म व समाजसेवा यांचा संगम – 20% अध्यात्म व 80% समाजसेवा या तत्त्वानुरूप कार्य.',
    'vision-point-2': 'भारतीय संस्कृती संवर्धन – परंपरा आणि मूल्ये पुढील पिढ्यांपर्यंत पोहोचवणे.',
    'vision-point-3': 'बालसंस्कार वर्ग – राष्ट्रसेवा हेतू लहान मुलांमध्ये संस्कार रुजवून सुसंस्कारीत पिढी घडवणे.',
    'vision-point-4': 'ग्रामअभियान – गावोगावी जाऊन जनसामान्यांचे प्रश्नांवर मोफत मार्गदर्शन करणे.',
    'vision-point-5': 'राष्ट्रीय एकात्मता – समाजात ऐक्य, बंधुता आणि राष्ट्रप्रेम टिकवून ठेवणे.',
    'hero-card-gurupeeth-title': 'श्री गुरुपीठ, त्र्यंबकेश्वर',
    'hero-card-gurupeeth-desc': 'आध्यात्मिक केंद्र आणि समाज सेवा केंद्र',
    'hero-card-hospital-title': 'सद्गुरू मोरेदादा चॅरिटेबल हॉस्पिटल',
    'hero-card-hospital-desc': 'नियोजित बहु-विशेष रुग्णालय आणि आरोग्य सेवा',
    'hero-card-agriculture-title': 'जागतिक कृषी महोत्सव',
    'hero-card-agriculture-desc': 'सेंद्रिय आणि नैसर्गिक शेतीचा उत्सव',
    'hero-card-cta': 'अधिक जाणून घ्या 👉'
  },
  en: {
    'nav-home': 'Home',
    'nav-about': 'About',
    'nav-mission': 'Mission & Vision',
    'nav-activities': 'Activities',
    'nav-projects': 'Gurupeeth Projects',
    'nav-vibhag': 'Vibhags',
    'nav-wisdom': 'Wisdom',
    'nav-datta-dham': 'Datta Dham',
    'nav-contact': 'Contact',
    'nav-donate': 'Donate',
    'hero-title': 'Welcome to',
    'hero-title-accent': 'Shree Swami Samarth Seva Marg, Dindori Pranit',
    'hero-desc': 'A community-led spiritual & service organisation focused on wisdom, rural development, health, and cultural heritage.',
    'activities-title': 'Activities',
    'activities-desc': 'Current initiatives and community programs.',
    'events-title': 'Upcoming Events',
    'events-desc': 'Join the next events and community gatherings.',
    'recent-events-title': 'Recent Events',
    'recent-events-desc': 'A look back at our past events and community gatherings.',
    'projects-title': 'Gurupeeth Projects',
    'projects-desc': 'Highlights of completed service projects and social infrastructure.',
    'mission-title': 'Mission',
    'mission-desc': 'Serving humanity through 18 different Vibhag related to human life.',
    'mission-quote': 'Service to man is service to God with the help of 18 different Vibhag related to human life.',
    'mission-details': 'Our mission is to serve humanity through various initiatives spanning healthcare, education, agriculture, spiritual guidance, and more.',
    'contact-title': 'Contact',
    'involved-title': 'Get involved',
    'involved-desc': 'Support free food distribution, health services, and education programs. Your contribution helps run temples, hospitals, and rural development initiatives.',
    'seva-marg-mission': 'Mission',
    'mission-point-1': 'Integration of Science and Spirituality – Implementing social welfare initiatives.',
    'mission-point-2': 'Healthcare Services – Free services and guidance for various ailments, and providing rare Ayurvedic medicines.',
    'mission-point-3': 'Protection of Values-Culture-Religion-Nation – Working on the principle "If values survive, culture survives; if culture survives, religion survives; if religion survives, nation survives".',
    'mission-point-4': 'Free Service and Counseling – Guidance on various life issues based on spiritual services.',
    'mission-point-5': 'Poison-free Food – Creating awareness about sustainable farming, proper diet, and environmentally friendly lifestyle.',
    'mission-point-6': 'Global Agriculture Festival – Ancient Indian agricultural-sage traditions and cultural philosophy.',
    'mission-point-7': 'Kanyadan Scheme – Free weddings for youth from farmer, soldier, and economically disadvantaged families.',
    'mission-point-8': 'Employment and Women Empowerment – Employment for unemployed, free industry training, skill development, women empowerment through savings groups.',
    'mission-point-9': 'Peace of Mind – Restoring lost peace and self-confidence.',
    'seva-marg-vision': 'Vision',
    'vision-point-1': 'Confluence of Spirituality and Social Service – Working according to the principle of 20% spirituality and 80% social service.',
    'vision-point-2': 'Promotion of Indian Culture – Passing on traditions and values to future generations.',
    'vision-point-3': 'Balsanskar Classes – Building a well-cultured generation by instilling values in children for national service.',
    'vision-point-4': 'Village Campaign – Going village to village providing free guidance on common people\'s problems.',
    'vision-point-5': 'National Integration – Maintaining unity, brotherhood and patriotism in society.',
    'hero-card-gurupeeth-title': 'Shree Gurupeeth, Trimbakeshwar',
    'hero-card-gurupeeth-desc': 'Spiritual center & community service hub',
    'hero-card-hospital-title': 'Sadguru Moredada Charitable Hospital',
    'hero-card-hospital-desc': 'Planned multi-specialty hospital & healthcare outreach',
    'hero-card-agriculture-title': 'Global Agriculture Festival',
    'hero-card-agriculture-desc': 'Celebrating organic & natural farming initiatives',
    'hero-card-cta': 'Click here to learn more 👉'
  },
};


const HomePage = () => {
  const { lang, setLang } = useContext(LanguageContext);

  // ===== ACTIVITIES DATA BASED ON LANGUAGE =====
  const currentActivities = activitiesData[lang] || activitiesData['en'];

  const [carouselScroll, setCarouselScroll] = useState(0);
  const carouselRef = useRef(null);

  const scrollCarousel = (direction) => {
    const carousel = carouselRef.current;
    if (!carousel) return;
    
    const scrollAmount = 320;
    const newScroll = direction === 'left' 
      ? Math.max(0, carouselScroll - scrollAmount)
      : carouselScroll + scrollAmount;
    
    carousel.scrollTo({
      left: newScroll,
      behavior: 'smooth'
    });
    
    setCarouselScroll(newScroll);
  };

  // ===== EVENTS LOGIC WITH useMemo - UPDATED =====
  const { upcomingEvents, recentEvents } = useMemo(() => {
    const currentEvents = eventsData[lang] || eventsData['en'];
    
    console.log('🔄 Recalculating events for language:', lang);
    console.log('📅 Total events:', currentEvents.length);
    
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    console.log('📆 Today:', today.toISOString().split('T')[0]);
    
    const upcoming = [];
    const recent = [];
    
    currentEvents.forEach(event => {
      // Check if endDate exists
      if (!event.endDate) {
        console.error('❌ Event missing endDate:', event.title);
        return;
      }
      
      // Parse the endDate field (format: YYYY-MM-DD)
      const eventEndDate = new Date(event.endDate);
      console.log(`📌 ${event.title} | endDate: ${event.endDate} | Parsed: ${eventEndDate.toISOString().split('T')[0]} | Is upcoming: ${eventEndDate >= today}`);
      
      const eventWithDateObj = { ...event, dateObj: eventEndDate };
      
      if (eventEndDate >= today) {
        console.log('✅ Upcoming:', event.title);
        upcoming.push(eventWithDateObj);
      } else {
        console.log('⏪ Recent:', event.title);
        recent.push(eventWithDateObj);
      }
    });
    
    // Sort upcoming events from soonest to latest
    upcoming.sort((a, b) => a.dateObj - b.dateObj);
    
    // Sort recent events from most recent to oldest
    recent.sort((a, b) => b.dateObj - a.dateObj);
    
    console.log('✨ Final Results - Upcoming:', upcoming.length, 'Recent:', recent.length);
    
    return {
      upcomingEvents: upcoming,
      recentEvents: recent
    };
  }, [lang]); // Recalculate when language changes

  
  // Activity Detail Modal State
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [showActivityPopup, setShowActivityPopup] = useState(false);

  const openActivityPopup = (activity) => {
    setSelectedActivity(activity);
    setShowActivityPopup(true);
    document.body.style.overflow = 'hidden';
  };

  const closeActivityPopup = () => {
    setShowActivityPopup(false);
    setSelectedActivity(null);
    document.body.style.overflow = 'auto';
  };

  const handleImageError = (event) => {
    event.target.src = '/path/to/fallback-image.jpg';
    event.target.onerror = null;
  };

  const renderEventPhotos = (photos) => {
    return photos.map((photo, index) => (
      <img 
        key={index}
        src={photo} 
        alt={`Event photo ${index + 1}`}
        className="event-photo"
        onError={handleImageError}
        loading="lazy"
      />
    ));
  };


  // ===== EVENT POPUP STATE =====
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [showEventPopup, setShowEventPopup] = useState(false);
  const [isRecentEvent, setIsRecentEvent] = useState(false);

  // ===== EVENT POPUP HANDLERS =====
  const openEventPopup = (event, isRecent = false) => {
    setSelectedEvent(event);
    setShowEventPopup(true);
    setIsRecentEvent(isRecent);
    document.body.style.overflow = 'hidden';
  };
  
  const closeEventPopup = () => {
    setShowEventPopup(false);
    setSelectedEvent(null);
    setIsRecentEvent(false);
    document.body.style.overflow = 'auto';
  };

  const t = (key) => {
    return translations[lang][key] || translations['en'][key];
  };

  const currentYear = new Date().getFullYear();

  // Scroll animation effect
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    }, observerOptions);

    const elements = document.querySelectorAll('.scroll-animate');
    elements.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <>
      {/* ===== EVENT POPUP MODAL ===== */}
      {showEventPopup && selectedEvent && (
        <div className="event-popup-overlay" onClick={closeEventPopup}>
          <div className="event-popup-container" onClick={(e) => e.stopPropagation()}>
            {/* Close Button */}
            <button className="event-popup-close" onClick={closeEventPopup}>
              ✕
            </button>

            {/* Popup Header */}
          <div className="event-popup-header">
          <h2>{selectedEvent.title}</h2>
          <p className="event-subtitle">{selectedEvent.subtitle}</p>
          <div className="event-date-badge">{selectedEvent.date}</div>
        </div>
            {/* Popup Content */}
            <div className="event-popup-content">
              
              {/* Photo Gallery */}
              {selectedEvent.photos && selectedEvent.photos.length > 0 && (
                <div className="event-section">
                  <h3>{lang === 'mr' ? 'फोटो गॅलरी' : 'Photo Gallery'}</h3>
                  <div className="event-photo-grid">
                    {selectedEvent.photos.map((photo, idx) => (
                      <img
                        key={idx}
                        src={photo}
                        alt={`${selectedEvent.title} photo ${idx + 1}`}
                        className="event-photo"
                        onError={(e) => {
                          e.target.src = '/images/placeholder.jpg';
                          e.target.onerror = null;
                        }}
                        loading="lazy"
                      />
                    ))}
                  </div>
                </div>
              )}

              {/* Event Description */}
              <div className="event-section">
                <h3>📋 About the Event</h3>
                <p className="event-description">{selectedEvent.description}</p>
              </div>

              {/* Event Highlights */}
              <div className="event-section">
                <h3>✨ Event Highlights</h3>
                <ul className="event-highlights-list">
                  {selectedEvent.highlights.map((highlight, index) => (
                    <li key={index}>{highlight}</li>
                  ))}
                </ul>
              </div>

              {/* Videos */}
              {selectedEvent.videos && selectedEvent.videos.length > 0 && (
                <div className="event-section">
                  <h3>🎥 Videos</h3>
                  <div className="event-video-grid">
                    {selectedEvent.videos.map((video, index) => (
                      <div key={index} className="event-video-wrapper">
                        <h4>{video.title}</h4>
                        <iframe
                          src={video.url}
                          title={video.title}
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        ></iframe>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Venue Information */}
              <div className="event-section event-venue-section">
                <h3>📍 Venue Details</h3>
                <div className="venue-card">
                  <h4>{selectedEvent.venue.name}</h4>
                  <p className="venue-address">{selectedEvent.venue.address}</p>
                  <p className="venue-timings"><strong>Timings:</strong> {selectedEvent.timings}</p>
                  <a 
                    href={selectedEvent.venue.mapLink} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="venue-map-link"
                  >
                    📌 View on Google Maps
                  </a>
                </div>
              </div>

            </div>

            {/* Popup Footer */}
            <div className="event-popup-footer">
              {!isRecentEvent && (
                <button className="btn-register" onClick={selectedEvent.registerlink ? () => window.open(selectedEvent.registerlink, '_blank') : null}>
                  {lang === 'mr' ? 'नोंदणी करा' : 'Register for Event'}
                </button>
              )}
              {!isRecentEvent && (
                <button className="btn-share">
                  {lang === 'mr' ? 'शेअर करा' : 'Share Event'}
                </button>
              )}
              {isRecentEvent && (
                <div className="recent-event-badge">
                  <span className="past-event-icon">📅</span>
                  <span>{lang === 'mr' ? 'मागील इव्हेंट' : 'Past Event'}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {/* ===== END EVENT POPUP ===== */}

      <Header />
      <main>
        <section id="home" className="wrap hero scroll-animate" aria-label="Hero">
          <div className="hero-left">
            <h1 id="hero-title">
              Welcome to,
              <span className="accent">{t('hero-title-accent')}</span>
            </h1>

            <p id="hero-desc">
              {t('hero-desc')}
            </p>

            {/* ===== COMPACT REELS CAROUSEL ===== */}
            <div className="reels-section-wrapper">
              <CompactReelsCarousel />
            </div>
          </div>
          <aside className="hero-right" aria-label="Highlights">
            {/* Shree Gurupeeth, Trimbakeshwar */}
            <Link
              to="/shree-gurupeeth"
              className="hero-card"
              style={{ textDecoration: "none", color: "inherit", cursor: "pointer" }}
            >
              <img src={GuruPeethLogoImg} alt={t('hero-card-gurupeeth-title')} />
              <div>
                <h4>{t('hero-card-gurupeeth-title')}</h4>
                <p className="meta">
                  {t('hero-card-gurupeeth-desc')}
                </p>
                <p style={{ color: "var(--primary)", fontWeight: "700" }}>
                  {t('hero-card-cta')}
                </p>
              </div>
            </Link>
            
            {/* Sadguru Moredada Charitable Hospital */}
            <Link
              to="/sadguru-hospital"
              className="hero-card"
              style={{ textDecoration: "none", color: "inherit", cursor: "pointer" }}
            >
              <img src={SHospital} alt={t('hero-card-hospital-title')} />
              <div>
                <h4>{t('hero-card-hospital-title')}</h4>
                <p className="meta">
                  {t('hero-card-hospital-desc')}
                </p>
                <p style={{ color: "var(--primary)", fontWeight: "700" }}>
                  {t('hero-card-cta')}
                </p>
              </div>
            </Link>
            
            {/* Global Agriculture Festival */}
            <a
              href="https://www.krushimahotsav.org/"
              target="_blank"
              rel="noopener noreferrer"
              className="hero-card"
              style={{ textDecoration: "none", color: "inherit", cursor: "pointer" }}
            >
              <img src={jkmLogo} alt={t('hero-card-agriculture-title')} />
              <div>
                <h4>{t('hero-card-agriculture-title')}</h4>
                <p className="meta">
                  {t('hero-card-agriculture-desc')}
                </p>
                <p style={{ color: "var(--primary)", fontWeight: "700" }}>
                  {t('hero-card-cta')}
                </p>
              </div>
            </a>
          </aside>
        </section>
     
        <DailyPanchang />

        <div className="divider"></div>

        {/* ===== UPDATED ACTIVITIES SECTION ===== */}
        <section id="activities" className="wrap scroll-animate" aria-label="Activities and Events">
          <h2 className="section-title">{t('activities-title')}</h2>
          <p className="muted-desc">{t('activities-desc')}</p>
          
          <div className="carousel-container">
            {/* Left Navigation Button */}
            <button 
              className="carousel-nav-btn carousel-nav-left"
              onClick={() => scrollCarousel('left')}
              aria-label="Scroll left"
            >
              ‹
            </button>

            {/* Right Navigation Button */}
            <button 
              className="carousel-nav-btn carousel-nav-right"
              onClick={() => scrollCarousel('right')}
              aria-label="Scroll right"
            >
              ›
            </button>

            <div className="carousel">
              <div 
                className="carousel-viewport" 
                ref={carouselRef}
              >
                <div className="carousel-track" aria-hidden="false" role="list">
                  {/* Duplicate array for infinite scroll effect */}
                  {[...currentActivities, ...currentActivities].map((activity, index) => (
                    <article 
                      className="card clickable-card" 
                      role="listitem" 
                      key={`${activity.id}-${index}`}
                      onClick={() => openActivityPopup(activity)}
                      style={{ cursor: 'pointer' }}
                    >
                      <img src={activity.thumbnail} alt={activity.title} />
                      <div className="card-body">
                        <div className="meta">{activity.date}</div>
                        <div className="card-title">{activity.title}</div>
                        <p className="card-description">{activity.description}</p>
                        <div style={{ marginTop: 'auto' }}>
                          <span style={{ color: 'var(--primary)', fontWeight: '700' }}>
                            {lang === 'mr' ? 'अधिक वाचा →' : 'Read More →'}
                          </span>
                        </div>
                      </div>
                    </article>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ===== ACTIVITY DETAIL POPUP ===== */}
        {showActivityPopup && selectedActivity && (
          <div className="activity-popup-overlay" onClick={closeActivityPopup}>
            <div className="activity-popup-container" onClick={(e) => e.stopPropagation()}>
              {/* Close Button */}
              <button className="activity-popup-close" onClick={closeActivityPopup}>
                ✕
              </button>

              {/* Popup Header */}
              <div className="activity-popup-header">
                <h2>{selectedActivity.title}</h2>
                <div className="activity-date-badge">{selectedActivity.date}</div>
              </div>

              {/* Popup Content */}
              <div className="activity-popup-content">
                
                {/* Photo Gallery */}
                {selectedActivity.photos && selectedActivity.photos.length > 0 && (
                  <div className="activity-section">
                    <h3>📸 {lang === 'mr' ? 'फोटो गॅलरी' : 'Photo Gallery'}</h3>
                    <div className="activity-photo-grid">
                      {selectedActivity.photos.map((photo, index) => (
                        <img 
                          key={index} 
                          src={photo} 
                          alt={`${selectedActivity.title} - ${index + 1}`}
                          className="activity-photo"
                        />
                      ))}
                    </div>
                  </div>
                )}

                {/* Full Content */}
                <div className="activity-section">
                  <div 
                    className="activity-full-content"
                    dangerouslySetInnerHTML={{ __html: selectedActivity.fullContent }}
                  />
                </div>

                {/* Videos */}
                {selectedActivity.videos && selectedActivity.videos.length > 0 && (
                  <div className="activity-section">
                    <h3>🎥 {lang === 'mr' ? 'व्हिडिओ' : 'Videos'}</h3>
                    <div className="activity-video-grid">
                      {selectedActivity.videos.map((video, index) => (
                        <div key={index} className="activity-video-wrapper">
                          <h4>{video.title}</h4>
                          <iframe
                            src={video.url}
                            title={video.title}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                          ></iframe>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Location */}
                <div className="activity-section activity-location-section">
                  <h3>📍 {lang === 'mr' ? 'स्थान' : 'Location'}</h3>
                  <div className="location-card">
                    <p className="location-text">{selectedActivity.location}</p>
                  </div>
                </div>

              </div>

              {/* Popup Footer */}
              <div className="activity-popup-footer">
                <button 
                  className="btn-volunteer"
                  onClick={() => navigate('/contact')}
                >
                  {lang === 'mr' ? 'स्वयंसेवक व्हा' : 'Become a Volunteer'}
                </button>
                <button className="btn-share">
                  {lang === 'mr' ? 'शेअर करा' : 'Share'}
                </button>
              </div>
            </div>
          </div>
        )}

        <div className="divider"></div>

        {/* ===== MODIFIED: UPCOMING EVENTS SECTION ===== */}
        {upcomingEvents.length > 0 && (
          <section id="events" className="wrap scroll-animate" aria-label="Upcoming events">
            <h2 className="section-title">{t('events-title')}</h2>
            <p className="muted-desc">{t('events-desc')}</p>
            <div className="grid" role="list">
              {upcomingEvents.map((event) => (
                <div 
                  key={event.id}
                  className="small-card event-card-clickable" 
                  role="listitem"
                  onClick={() => openEventPopup(event)}
                  style={{ cursor: 'pointer' }}
                  tabIndex={0}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      openEventPopup(event);
                    }
                  }}
                >
                  <img src={event.thumbnail} alt={event.title} loading="lazy" />
                  <h4 style={{ marginBottom: '6px' }}>{event.title}</h4>
                  <p className="meta">{event.subtitle}</p>
                  <p className="event-date-text">{event.date}</p>
                  <p style={{ color: 'var(--primary)', fontWeight: '700', marginTop: '8px' }}>
                    👉 {lang === 'mr' ? 'तपशीलासाठी क्लिक करा' : 'Click for details'}
                  </p>
                </div>
              ))}
            </div>
          </section>
        )}
        {/* ===== END OF UPCOMING EVENTS SECTION ===== */}

        {/* ===== NEW SECTION: RECENT EVENTS ===== */}
        {recentEvents.length > 0 && (
          <>
            <div className="divider"></div>
            <section id="recent-events" className="wrap scroll-animate compact-layout" aria-label="Recent events">
              <h2 className="section-title">{t('recent-events-title')}</h2>
              <p className="muted-desc">{t('recent-events-desc')}</p>
              <div className="grid" role="list">
                {recentEvents.map((event) => (
                  <div 
                    key={event.id}
                    className="small-card event-card-clickable" 
                    role="listitem"
                    onClick={() => openEventPopup(event, true)}
                    style={{ cursor: 'pointer' }}
                    tabIndex={0}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        openEventPopup(event, true);
                      }
                    }}
                  >
                    <img src={event.thumbnail} alt={event.title} loading="lazy" />
                    <h4 style={{ marginBottom: '6px' }}>{event.title}</h4>
                    <p className="meta">{event.subtitle}</p>
                    <p className="event-date-text">{event.date}</p>
                    <p style={{ color: 'var(--primary)', fontWeight: '700', marginTop: '8px' }}>
                      👉 {lang === 'mr' ? 'तपशीलासाठी क्लिक करा' : 'Click for details'}
                    </p>
                  </div>
                ))}
              </div>
            </section>
          </>
        )}
        {/* ===== END OF RECENT EVENTS SECTION ===== */}

        <div className="divider"></div>
        
        {/* Mission Section */}
        <section id="mission" className="wrap scroll-animate" aria-label="Mission">
          <div style={{ marginTop: '40px' }}>
            <h2 className="section-title">{t('seva-marg-mission')}</h2>
            <div style={{ marginTop: '14px' }} className="mission-callout">
              <ul className="mission-vision-list">
                <li>{t('mission-point-1')}</li>
                <li>{t('mission-point-2')}</li>
                <li>{t('mission-point-3')}</li>
                <li>{t('mission-point-4')}</li>
                <li>{t('mission-point-5')}</li>
                <li>{t('mission-point-6')}</li>
                <li>{t('mission-point-7')}</li>
                <li>{t('mission-point-8')}</li>
                <li>{t('mission-point-9')}</li>
              </ul>
            </div>
          </div>

          <div style={{ marginTop: '40px' }}>
            <h2 className="section-title">{t('seva-marg-vision')}</h2>
            <div style={{ marginTop: '14px' }} className="callout">
              <ul className="mission-vision-list">
                <li>{t('vision-point-1')}</li>
                <li>{t('vision-point-2')}</li>
                <li>{t('vision-point-3')}</li>
                <li>{t('vision-point-4')}</li>
                <li>{t('vision-point-5')}</li>
              </ul>
            </div>
          </div>
        </section>
        
        <div className="divider"></div>

      </main>

      {/* Floating YouTube Video Ad */}
      <aside className="floating-video-ad scroll-animate" aria-label="Featured Video">
        <div className="floating-video-card">
          <div className="floating-ad-header">
            <span className="ad-label">Featured Video</span>
            <button className="minimize-btn" onClick={() => document.querySelector('.floating-video-ad').style.display = 'none'}>✕</button>
          </div>
          <div className="floating-video-wrapper">
            <iframe
              width="100%"
              height="180"
              src="https://www.youtube.com/embed/cqvWALRKgks?si=cP7yIRX3E3bZoLg4"
              title="Featured Video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
          <div className="floating-ad-footer">
            <p>Watch Our Latest Update</p>
          </div>
        </div>
      </aside>

      {/* Floating Social Media Card */}
      <section id="social-media" className="social-media-section scroll-animate" aria-label="Social Media">
        <div className="social-media-card">
          <h2 className="section-title">Follow Us</h2>
          <div className="social-links">
            <a href="https://www.facebook.com/dindoripranit/" target="_blank" rel="noopener noreferrer" className="social-item facebook" aria-label="Facebook">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
                <path d="M22.675 0h-21.35C.597 0 0 .597 0 1.326v21.348C0 23.403.597 24 1.326 24H12.82v-9.294H9.692V11.41h3.128V8.797c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.464.099 2.797.143v3.24l-1.922.001c-1.506 0-1.797.717-1.797 1.767v2.31h3.587l-.467 3.296h-3.12V24h6.116C23.403 24 24 23.403 24 22.674V1.326C24 .597 23.403 0 22.675 0z"/>
              </svg>
            </a>

            <a href="https://www.instagram.com/dindoripranitsevamarg_official/" target="_blank" rel="noopener noreferrer" className="social-item instagram" aria-label="Instagram">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="22" height="22">
                <path fill="currentColor" d="M224,202.66A53.34,53.34,0,1,0,277.34,256,53.38,53.38,0,0,0,224,202.66ZM400,32H48A48,48,0,0,0,0,80V432a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V80A48,48,0,0,0,400,32ZM224,338a82,82,0,1,1,82-82A82,82,0,0,1,224,338Zm85.5-148a19.5,19.5,0,1,1,19.5-19.5A19.5,19.5,0,0,1,309.5,190Z"/>
              </svg>
            </a>

            <a href="https://www.youtube.com/channel/UC5mIaJno_3MmoNbn0NWwwJg" target="_blank" rel="noopener noreferrer" className="social-item youtube" aria-label="YouTube">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="22" height="22" fill="currentColor">
                <path d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.338-48.634C458.781 64 288 64 288 64S117.22 64 74.682 75.449c-23.55 6.358-42.056 24.984-48.337 48.634C16 167.72 16 256 16 256s0 88.28 10.345 131.917c6.281 23.65 24.787 42.276 48.338 48.634C117.219 448 288 448 288 448s170.781 0 213.317-11.449c23.55-6.358 42.057-24.984 48.338-48.634C560 344.28 560 256 560 256s0-88.28-10.345-131.917ZM232 334V178l142 78-142 78Z"/>
              </svg>
            </a>

            <a href="https://whatsapp.com/channel/0029VaA1P7fEwEjuj5w4kb3C" target="_blank" rel="noopener noreferrer" className="social-item whatsapp" aria-label="WhatsApp Channel">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="22" height="22" fill="currentColor">
                <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/>
              </svg>
            </a>

            <a href="https://twitter.com/yourTwitterHandle" target="_blank" rel="noopener noreferrer" className="social-item twitter" aria-label="Twitter">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="22" height="22" fill="currentColor">
                <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/>
              </svg>
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomePage;